import React__default from 'react';
import styles from './TitleWithEdit.module.scss.js';
import { AutoshipLogo } from '../../common/autoship-logo/AutoshipLogo.js';
import { Anchor, P2 } from '@zooplus/ui-components';
import { getUrlLocalised } from '../../../utils/utils.js';
import 'react/jsx-runtime';
import Pencil from '../../../node_modules/@zooplus/icons/dist/es/components/Pencil.js';
import { useTranslation } from '../../../hooks/use-translations.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const TitleWithEdit = (props) => {
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    return (React__default.createElement("div", { className: `${styles.title} ${props.noIntervalSelected ? styles.noIntervalTitle : ''}` },
        React__default.createElement(AutoshipLogo, { logoSize: props.logoSize }),
        React__default.createElement(Anchor, { size: 'small', isBold: true, href: getUrlLocalised(t, '/checkout/cart', props.noIntervalSelected ? 'subscription-offer-cart-no-interval' : undefined) },
            React__default.createElement(P2, { bold: true, className: styles.editLink },
                props.noIntervalSelected ? t('checkout.common.delivery-interval-new.schedule') : t('checkout.common.edit'),
                React__default.createElement(Pencil, null)))));
};

export { TitleWithEdit };
//# sourceMappingURL=TitleWithEdit.js.map
